import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';

import { ResetPasswordResponse } from '../types';

export type ResetPasswordDetails = {
  email?: string;
  mobile_number?: string;
  otp: string;
  password1: string;
  password2: string;
};

export const resetPassword = (
  data: ResetPasswordDetails
): Promise<ResetPasswordResponse.Root> => {
  return axios.post('/user/v1/reset-password', data);
};

// Mock handler
const mockResetPasswordResponse: ResetPasswordResponse.Root = {
  status: 'Success',
  message: 'Password reset successfully',
};

export const resetPasswordMockHandler = http.post(
  `${env.API_URL}/user/v1/reset-password`,
  async ({ request }): Promise<HttpResponse<ResetPasswordResponse.Root>> => {
    const body = (await request.json()) as ResetPasswordDetails;
    const { email, password1, password2, mobile_number, otp } = body;

    // Simulate authentication validation
    if (!email && !mobile_number) {
      return HttpResponse.json(
        { status: 'Failure', message: 'Email or mobile number is required' },
        { status: 400 }
      );
    }
    if (!otp) {
      return HttpResponse.json(
        { status: 'Failure', message: 'OTP is required' },
        { status: 400 }
      );
    }
    if (!password1 || !password2) {
      return HttpResponse.json(
        {
          status: 'Failure',
          message: 'Password and confirm password are required',
        },
        { status: 400 }
      );
    }
    if (password1 !== password2) {
      return HttpResponse.json(
        {
          status: 'Failure',
          message: 'Password and confirm password do not match',
        },
        { status: 401 }
      );
    }

    return HttpResponse.json(mockResetPasswordResponse);
  }
);
